import React, { useContext, useEffect, useState } from 'react';
import { TextField, Button, Snackbar, Grid, Typography, Modal, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Alert } from '@mui/lab';
import axios from 'axios';
import CollapsibleTable from './CollapsibleTable';
import AppContext from '../context/AppContext';

const AddGatewayForm = () => {
  const storedUserRole = localStorage.getItem('userRole');

    const [input, setInput] = useState({
        location: '',
        description: '',
        macAddress: '',
        position: '',
        owner: '',
        model: ''
      });
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { gateway, setGateway, location } = useContext(AppContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(()=>{
    const handleResize = ()=> setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return ()=> window.removeEventListener("resize", handleResize);
  },[isMobile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/add/gateway`,
        { location_name: input.location, description: input.description, device_id: input.macAddress, position: input.position, owner: input.owner, model: input.model }
      );
      if(response.data.status == 'success'){
        setInput({...input, location:'', description:'', macAddress:'', position:'', owner:'', model: ''})
        setGateway([response.data.gateway_data, ...gateway])
        setMessage(response.data.message);
        setSeverity('success');
        setOpen(true);
        setOpenModal(false)
      }

    } catch (error) {
        console.log(error);
      setMessage(error.response.data.error || 'Failed to add asset');
      setSeverity('error');
      setOpen(true);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  const handleCloseModal = () =>{
    setOpenModal(false)
  }
  const handleOpenModal = async () =>{
    // const responses = await axios.get(
    //   `${process.env.REACT_APP_URL}/api/v1/beacon/get/location`,
    //   );
    setOpenModal(true)
    
  }
  return (
    <Grid container spacing={2}>
        <Grid item xs={12}>
            <Typography style={{ display: 'flex', justifyContent: 'flex-end', border: "none", backgroundColor: "transparent", cursor: "pointer", color: storedUserRole == 'demo' ? 'grey' :'green', fontSize: 18}} onClick={storedUserRole == 'demo' ? ()=> '' : handleOpenModal}>+ Add Gateway</Typography>
            
            <CollapsibleTable modal={openModal} path='api/v1/beacon/get/gateway'/>
            <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            width: isMobile ? 300 : 600,
            maxHeight: "100%",

            overflowY: "auto",
            overflowX: "auto",
            backgroundColor: "white",
            boxShadow: 24,
            padding: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "flex-end",
              cursor: "pointer",
            }}
            onClick={handleCloseModal}
          >
            <img style={{ width: 20, height: 20 }} src="/Close.png" />
          </div>
          <form onSubmit={handleSubmit} style={{ flexDirection: "column", display: "flex" }}>
          <FormControl margin="normal">
        <InputLabel id="asset-select-label">Location</InputLabel>
        <Select
          labelId="asset-select-label"
          id="asset-select"
          name='location'
          value={input.location}
          onChange={(e) =>  handleInputChange(e)}
          label="Select Location"
        >
          {location?.map((asset) => (
            <MenuItem key={asset.id} value={asset.name}>
              {" "}
              {asset.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
          <FormControl margin="normal">
        <InputLabel id="asset-select-label">Select Make</InputLabel>
        <Select
          labelId="asset-select-label"
          id="asset-select"
          name='owner'
          value={input.owner}
          onChange={(e) =>  handleInputChange(e)}
          label="Select Owner"
        >
            <MenuItem value="CoreData">
              Coredata
            </MenuItem>
            <MenuItem value="Moko">
              Moko
            </MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Model"
        name='model'
        value={input.model}
        onChange={(e) =>  handleInputChange(e)}
        margin="normal"
        required
      />

      <TextField
        label="Description"
        name='description'
        value={input.description}
        onChange={(e) =>  handleInputChange(e)}
        margin="normal"
      />
      <TextField
        label="Position"
        name='position'
        value={input.position}
        onChange={(e) =>  handleInputChange(e)}
        margin="normal"
        required
      />
      <TextField
        label="Device Id"
        name='macAddress'
        value={input.macAddress}
        onChange={(e) =>  handleInputChange(e)}
        margin="normal"
        required
      />

      <Button type="submit" variant="contained" color="primary" >
        Add
      </Button>
     
    </form>
           
        </div>
      </Modal>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
        </Grid>
      
    </Grid>

  );
};

export default AddGatewayForm;
